import { useEffect } from 'react'

const FONT_URL_MAP: Record<string, string> = {
  'noto-sans':
    'https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;700&display=swap',
  'noto-serif':
    'https://fonts.googleapis.com/css2?family=Noto+Serif+KR:wght@400;700&display=swap',
  'gowun-batang':
    'https://fonts.googleapis.com/css2?family=Gowun+Batang:wght@400;700&display=swap',
  'nanum-myeongjo':
    'https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700&display=swap',
  'kopub-batang':
    'https://fonts.googleapis.com/css2?family=KoPub+Batang&display=swap',
}

export function useFontLoader(fontSlug: string | undefined) {
  useEffect(() => {
    if (!fontSlug) return
    const url = FONT_URL_MAP[fontSlug]
    if (!url) return
    const id = `font-${fontSlug}`
    if (document.getElementById(id)) return
    const link = document.createElement('link')
    link.id = id
    link.rel = 'stylesheet'
    link.href = url
    document.head.appendChild(link)
  }, [fontSlug])
}
